import { render } from "./BpmnDiagramActions.vue?vue&type=template&id=d287615e&scoped=true"
import script from "./BpmnDiagramActions.vue?vue&type=script&lang=js"
export * from "./BpmnDiagramActions.vue?vue&type=script&lang=js"

import "./BpmnDiagramActions.vue?vue&type=style&index=0&id=d287615e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d287615e"]])

export default __exports__